import { LOADED_PAGE } from "../actions/checkoutStore";

const _sentFbPages = new Set(); // keep track of which pages we've already emitted for

export default function FacebookEventManager(action, store) {
  if (action.type !== LOADED_PAGE || !store.checkoutStore || typeof window.fbq !== "function") return;

  const page = action.payload.page;

  if (_sentFbPages.has(page)) return;

  _sentFbPages.add(page);

  const { analytics_data } = store.checkoutStore;

  switch (page) {
    case "checkout":
      emitInitiateCheckout(analytics_data);
      break;
    case "payment":
      emitAddPaymentInfoEvent(analytics_data);
      break;
    case "success":
      emitPurchaseEvent(analytics_data);
      break;
  }
}

function emitInitiateCheckout(pixelData) {
  window.fbq("track", "InitiateCheckout", {
    source: "Jumpseller",
    value: pixelData.value,
    currency: pixelData.currency,
    content_name: document.title,
    content_type: "product",
    content_ids: pixelData.content_ids,
    contents: pixelData.contents,
    num_items: pixelData.products_count,
    referrer: document.referrer,
    userAgent: navigator.userAgent,
    language: navigator.language,
  });
}

function emitAddPaymentInfoEvent(pixelData) {
  window.fbq("track", "AddPaymentInfo", {
    source: "Jumpseller",
    value: pixelData.value,
    currency: pixelData.currency,
    content_ids: pixelData.content_ids,
    contents: pixelData.contents,
    referrer: document.referrer,
    userAgent: navigator.userAgent,
    language: navigator.language,
  });
}

function emitPurchaseEvent(pixelData) {
  if (!pixelData.is_first_time_seeing) return;

  window.fbq(
    "track",
    "Purchase",
    {
      source: "Jumpseller",
      value: pixelData.value,
      currency: pixelData.currency,
      content_name: document.title,
      content_type: "product",
      content_ids: pixelData.content_ids,
      contents: pixelData.contents,
      num_items: pixelData.products_count,
      referrer: document.referrer,
      userAgent: navigator.userAgent,
      language: navigator.language,
    },
    {
      eventID: pixelData.event_id,
    },
  );
}
